export const set_loading = (loading) => ({ type: "SET_LOADING", loading: loading })



// WEBPACK FOOTER //
// src/actions/loadingActions.js